<template>
    <v-container class="fill-height">
        <v-layout wrap class="pt-5">
            <v-row no-gutters>
                <v-col cols="8" class="my-3">
                    <Tab
                            :tabData="tabData"
                            width="230"
                            :has-v-n-c="hasVNC"
                            :showVNCTab="showVNCInput"
                    />
                </v-col>

                <v-col cols="4" class="my-3 text-right input-163" v-if="showVNCInput">
                    <v-text-field
                            v-model="vncPwd"
                            class="d-inline-flex"
                            name="password"
                            id="password"
                            type="password"
                            single-line
                            outlined
                            dense
                            placeholder="Enter vnc password"
                            v-on:keyup.enter="connect()"
                    ></v-text-field>
                    <Button
                            class="ml-3"
                            width="100"
                            :depressed="true"
                            :disabled="!vncPwd"
                            v-on:onClick="connect()"
                            :content="btnContent"
                    />
                </v-col>
                <v-col cols="12" class="mt-3" v-if="getLoadingStatus && isAuth">
                    <div class="d-flex align-center justify-center">
                        <Spinner :vncLoading="getVNCLoadingStatus" />
                    </div>
                </v-col>
                <router-view
                        :vncView="vncView"
                        :vncPwd="vncPwd"
                        :onConnect="connect"
                        v-show="!getLoadingStatus"
                />
            </v-row>
        </v-layout>
    </v-container>
</template>
<script>
    import Tab from "../components/common/Tab";
    import {
        // REALTIME_INTERACTIVE_SCAN,
        REALTIME_SCAN,
        REALTIME_SCAN_LANDING,
        SCAN_LIST,
        VNC_VIEWER
    } from "../utils/routes";
    import { createNamespacedHelpers, mapGetters } from "vuex";
    import Spinner from "../components/common/Spinner";
    import Button from "../components/common/Button";
    import { VNC_VIEWER_CONFIRM } from "../utils/constants";
    import asyncDataStatus from "../mixins/asyncDataStatus";
    const authHelper = createNamespacedHelpers("auth");
    const vncHelper = createNamespacedHelpers("vnc");

    export default {
        components: { Tab, Spinner, Button },
        name: "RealtimeScanLanding",
        mixins: [asyncDataStatus],
        methods: {
            ...vncHelper.mapActions(["fetchVNCStart", "fetchVNCStop"]),
            async connect(err = false) {
                const { scanId } = this.getVNCDetails;
                try {
                    if (!this.vncView) {
                        if (err) {
                            return;
                        }
                        await this.loadingStart();
                        await this.fetchVNCStart({
                            clientId: this.getSelectedClient,
                            scanId
                        });
                        this.vncView = true;
                        await this.loadingEnd();
                    } else {
                        if (err) {
                            this.vncPwd = "";
                            this.vncView = false;
                            return;
                        }
                        if (confirm(VNC_VIEWER_CONFIRM)) {
                            await this.fetchVNCStop({
                                clientId: this.getSelectedClient,
                                scanId
                            });
                            this.vncPwd = "";
                            this.vncView = false;
                            this.$router.push(`${SCAN_LIST.path}`);
                        }
                    }
                } catch (e) {
                    window.alert(e);
                }
            }
        },
        data() {
            return {
                vncPwd: "",
                vncView: false,
                tabData: [
                    {
                        link: `${REALTIME_SCAN_LANDING.path}${REALTIME_SCAN.path}`,
                        content: "REALTIME SCAN"
                    }
                    // {
                    //     link: `${REALTIME_SCAN_LANDING.path}/${REALTIME_INTERACTIVE_SCAN.path}`,
                    //     content: "REALTIME INTERACTIVE SCAN"
                    // }
                ]
            };
        },
        computed: {
            ...vncHelper.mapGetters(["getVNCDetails"]),
            ...mapGetters(["getLoadingStatus", "getVNCLoadingStatus"]),
            ...authHelper.mapGetters(["isAuth", "hasVNC", "getSelectedClient"]),
            btnContent() {
                return this.vncView ? "STOP" : "CONNECT";
            },
            showVNCInput() {
                return this.$route.name === VNC_VIEWER.name;
            }
        }
    };
</script>
